/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=1932d37e&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSidebar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=1932d37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1932d37e",
  null
  
)

export default component.exports